import React, {useCallback, useEffect} from 'react'
import {Row, Col, CustomerDialogButtonRow, DangerAlert} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {DialogDescription, DialogHeadline} from '../styles'

type DeleteEntryConfirmDialogProps = {
  params: {
    onConfirm: () => void
    target: string
    entryType?: string
  }
  closeDialog: () => void
  deleteErrorMessage?: string
  deletePending: boolean
  reset: () => void
}

const DeleteEntryConfirmDialog: React.FC<DeleteEntryConfirmDialogProps> = ({
  params,
  closeDialog,
  deleteErrorMessage,
  deletePending,
  reset,
}) => {
  const {onConfirm, target, entryType} = params
  const {t} = useTranslation('charon') // @todo fix translations

  useEffect(() => {
    if (reset) {
      reset()
    }
  }, [reset])

  const handleSubmit = useCallback(() => {
    onConfirm()
  }, [onConfirm])

  return (
    <>
      {deleteErrorMessage && (
        <Row>
          <Col col={10} offset={1}>
            <DangerAlert>{deleteErrorMessage}</DangerAlert>
          </Col>
        </Row>
      )}
      <Row mt={30}>
        <Col col={10} offset={1}>
          <DialogHeadline>
            {t(`${entryType || 'delete-menu-item'}.headline`, {itemName: target})}
          </DialogHeadline>
        </Col>
      </Row>
      <Row mt={20} mb={50}>
        <Col col={10} offset={1}>
          <DialogDescription>
            {t(`${entryType || 'delete-menu-item'}.description`)}
          </DialogDescription>
        </Col>
      </Row>
      <CustomerDialogButtonRow
        alert
        loading={deletePending}
        expectedSubmitDuration={2000}
        canSubmit={!deletePending}
        onSubmitClick={handleSubmit}
        submitText={t(`${entryType || 'delete-menu-item'}.cta-submit`)}
        hasCancel
        canCancel={!deletePending}
        cancelText={t(`${entryType || 'delete-menu-item'}.cta-cancel`)}
        onCancelClick={closeDialog}
      />
    </>
  )
}

export default DeleteEntryConfirmDialog
